import React, { useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import {
  CommunityConnectorMode,
  getModeFromStorage,
  saveFeatureFlagsToStorage,
} from '@src/utills/storage';
import { API } from '@src/api';
import { useAtom } from 'jotai';
import { loggedInAdvocateAtom } from '@src/global-state';
import { UserInfo } from '@src/api.types';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
// import * as data from 'advocate/.abyss/environments.json';
import { config } from '@uhg-abyss/web/tools/config';
export const Redirect = () => {
  const [loggedInAdvocate, setLoggedInAdvocate] = useAtom(loggedInAdvocateAtom);
  const { navigate } = useRouter();
  const [isLoading, setIsLoading] = React.useState(true);

  const redirect = async () => {
    setIsLoading(true);
    const sa: CommunityConnectorMode = getModeFromStorage();
    if (
      sa !== '' &&
      (sa === 'standalone' ||
        sa === 'maestro' ||
        sa === 'ICM' ||
        sa === 'maestroMedicare' ||
        sa === 'MedSup' ||
        sa === 'communityCare' ||
        sa === 'ICUE' ||
        sa === 'maestroIFP' ||
        sa === 'ACETEANDI' ||
        sa === 'ISETEANDI' ||
        sa === 'ACET')
    ) {
      if (loggedInAdvocate === null) {
        // The following  API call specifically targets bug DE647970 "Community Care and Maestro sender information not populating when challenged with login"
        // Presumably need to persist this user info to the loggedInAdvocate atom,
        //  but going to leave this as-is until that is needed.
        setLoggedInAdvocate((await API.getUserInfo())?.data as UserInfo);

        // setUserInfo
        saveFeatureFlagsToStorage(config('defaultFeatureFlags'));
        API.getFeatureFlags().then((respFeatureFlags) => {
          if (
            !!respFeatureFlags &&
            'status' in respFeatureFlags &&
            respFeatureFlags.status === 'success' &&
            'data' in respFeatureFlags &&
            Object.keys(respFeatureFlags.data).length > 0
          ) {
            saveFeatureFlagsToStorage(respFeatureFlags?.data);
          } else {
            const defaultFeatureFlags = config('defaultFeatureFlags');
            saveFeatureFlagsToStorage(defaultFeatureFlags);
          }
        });
      }

      navigate('/memberprofile');
    } else {
      navigate('/home');
    }
  };

  useEffect(() => {
    redirect();
  }, []);
  return (
    <React.Fragment>
      {isLoading ? (
        <div
          style={{
            zIndex: 999,
            backgroundColor: '#FFFFFF',
            opacity: 0.75,
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LoadingSpinner
            size="xl"
            isLoading={isLoading}
            ariaLoadingLabel="Downloading files"
          />
        </div>
      ) : (
        ``
      )}
      {/* <LoadingOverlay width={400} model="useOverlay-loading" /> */}
    </React.Fragment>
  );
};
